export enum messageTypes {
  MESSAGE = 'Message',
  FORWARD = 'Forward',
  RECIPIENTS_REMOVED = 'RecipientsRemoved',
  RECIPIENTS_ADDED = 'RecipientsAdded',
  AUTO_REPLY = 'AutoReply',
  MESSAGE_DELETED = 'MessageDeleted',
  MESSAGE_EDITED = 'MessageEdited',
}
